/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainer_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
